import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const getAllOpReportsListApi = async(MP, TCP, OP, currentYear, RBC, RBL, RF, ClientName, Phone, page) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/rapport/getAllOpRapportsList/${id}/${iv}?MP=${MP}&TCP=${TCP}&OP=${OP}&currentYear=${currentYear}&RBC=${RBC}&RBL=${RBL}&RF=${RF}&ClientName=${encodeURIComponent(ClientName || "")}&Phone=${encodeURIComponent(Phone || "")}&limit=10&page=${page}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getProspectionClientStatsApi = async (currentYear, TCP) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")
        const option = { headers: { Authorization: `Bearer ${token}` } }
        const res = await axios.get(
            `${API_URL}/api/rapport/prospectionClientStats/${id}/${iv}?currentYear=${currentYear}&TCP=${TCP}`,
            option
        );
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getProspectionClientReportsApi = async (currentYear, TCP, clientName) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")
        const option = { headers: { Authorization: `Bearer ${token}` } }
        const res = await axios.get(
            `${API_URL}/api/rapport/prospectionClientReports/${id}/${iv}?currentYear=${currentYear}&TCP=${TCP}&clientName=${encodeURIComponent(clientName)}`,
            option
        );
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getProspectionCultureStatsApi = async (currentYear, TCP) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")
        const option = { headers: { Authorization: `Bearer ${token}` } }
        const res = await axios.get(
            `${API_URL}/api/rapport/prospectionCultureStats/${id}/${iv}?currentYear=${currentYear}&TCP=${TCP}`,
            option
        );
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getProspectionTypeCultureStatsApi = async (currentYear, TCP) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")
        const option = { headers: { Authorization: `Bearer ${token}` } }
        const res = await axios.get(
            `${API_URL}/api/rapport/prospectionTypeCultureStats/${id}/${iv}?currentYear=${currentYear}&TCP=${TCP}`,
            option
        );
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getProspectionSolutionsStatsApi = async (currentYear, TCP) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")
        const option = { headers: { Authorization: `Bearer ${token}` } }
        const res = await axios.get(
            `${API_URL}/api/rapport/prospectionSolutionsStats/${id}/${iv}?currentYear=${currentYear}&TCP=${TCP}`,
            option
        );
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getProspectionConcurrencesStatsApi = async (currentYear, TCP, concurrenceType) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")
        const option = { headers: { Authorization: `Bearer ${token}` } }
        const res = await axios.get(
            `${API_URL}/api/rapport/prospectionConcurrencesStats/${id}/${iv}?currentYear=${currentYear}&TCP=${TCP}&concurrenceType=${concurrenceType}`,
            option
        );
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getAllOpReportsListAllApi = async(MP, TCP, OP, currentYear, RBC, RBL, RF, ClientName, Phone, total) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const limit = total > 0 ? total : 10000;
        const res = await axios.get(`${API_URL}/api/rapport/getAllOpRapportsList/${id}/${iv}?MP=${MP}&TCP=${TCP}&OP=${OP}&currentYear=${currentYear}&RBC=${RBC}&RBL=${RBL}&RF=${RF}&ClientName=${encodeURIComponent(ClientName || "")}&Phone=${encodeURIComponent(Phone || "")}&limit=${limit}&page=1`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
